export const SWITCH_PARTS = ['container', 'track', 'thumb'] as const;
